var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-overlay-popup": "" } },
    [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("dismiss")
            },
          },
        },
        [_vm._v("❌")]
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }